import * as React from "react";
import Box from "@mui/material/Box";
import classes from "../../../../Login/Login.module.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { ClassNames } from "@emotion/react";
import { Grid, TextField, styled } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import { postApiData } from "../../../../../components/utilities/nodeApiServices";
import { apiList } from "../../../../../components/utilities/nodeApiList";
import SweetAlertPopup from "../../../../../components/common/sweetAlertPopup";
import TextFieldForm from "../../../../../components/common/textFieldForm";
import { errorMessages } from "../../../../../components/utilities/formValidation";
import OTPInput from "react-otp-input";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useLanguage } from "../../../../../context/LanguageContext";
import BeneficiaryOTPExternal from "./BeneficiaryOTPExternal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: "30px",
};

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#FFFFFF",
  // backgroundColor: "#F84B67",
  backgroundColor: "#323232",
  border: "1px solid #CCC",
  borderRadius: "8px",
  paddingLeft: "15px",
  paddingRight: "15px",
  width: "183px",
  height: "50px",
  "&:hover": {
    background: "#808080",
    color: "white",
  },
}));

const ColorButton1 = styled(Button)(({ theme }) => ({
  color: "#FFFFFF",
  // backgroundColor: "#F84B67",
  // backgroundColor: "#323232",
  background: "var(--button-color)",
  border: "1px solid #CCC",
  borderRadius: "8px",
  paddingLeft: "15px",
  paddingRight: "15px",
  width: "183px",
  height: "40px",
  "&:hover": {
    background: "var(--button-hover-color)",
    color: "white",
  },
}));

const ColorButton2 = styled(Button)(({ theme }) => ({
  color: "#707070",

  // backgroundColor: "#F84B67",
  // backgroundColor: "#323232",
  background: "#FFF",
  border: "1px solid #707070",
  borderRadius: "8px",
  paddingLeft: "15px",
  paddingRight: "15px",
  width: "183px",
  height: "40px",
  "&:hover": {
    background: "var(--button-hover-color)",
    color: "white",
  },
}));

const defaultFormData = {
  accnumber: "",
  ifsccode: "",
  nickname: "",
  fullname: "",
  mobilenum: "",
  tpin: "",
};

export default function AddExtBeneficiary({
  open,
  handleOpenOTP,
  handleClose,
  setPayloadData,
  payloadData,
  payloads,
  response,
  handleCloseOTP,
  userId,
  handlerefresh,
}) {
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    register,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: defaultFormData,
    mode: "onChange",
  });

  const { loading, error, isAuthenticated, user } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();

  const [isloading, setIsloading] = useState(false);
  const [messege, setMessege] = useState();
  const [messegeColor, setMessegeColor] = useState();
  const [verificationResult, setVerificationResult] = useState(null);
  const [lastValidatedAcc, setLastValidatedAcc] = useState("");
  const [lastValidatedIFSC, setLastValidatedIFSC] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const accnumber = watch("accnumber");
  const ifsccode = watch("ifsccode");

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [isValidateButtonEnabled, setIsValidateButtonEnabled] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { t } = useLanguage();

  React.useEffect(() => {
    const accChanged = accnumber !== lastValidatedAcc;
    const ifscChanged = ifsccode !== lastValidatedIFSC;

    if (accChanged || ifscChanged) {
      setIsValidateButtonEnabled(accnumber && ifsccode);
    }
  }, [accnumber, ifsccode]);


  const popupAlert = (message, msgtype, msgicon) => {
    Swal.fire({
      title: msgtype,
      text: message,
      icon: msgicon,
    });
  };
  const [nameFromAPI, setNameFromAPI] = useState(false);
  const verifyAccountNumber = async () => {
    setIsloading(true);
    const payload = {
      accNo: accnumber,
      ifsc: ifsccode,
      custNo: user?.userId,
      sessionId: user?.sessionId,
    };
    try {
      const response = await postApiData(
        apiList.VERIFYEXTERNALBENEFICIARY,
        payload
      );
      if (response.status) {
        setVerificationResult(response.data);
        setMessege(response.message);
        setMessegeColor(response.status);
        setValue("accHolderName", response?.data?.name);
        setLastValidatedAcc(payload.accNo);
        setLastValidatedIFSC(payload.ifsc);
        setIsValidateButtonEnabled(false)
        const fetchedName = response?.data?.name || "";
        setValue("accName", fetchedName);

        if (fetchedName?.trim()) {
          setNameFromAPI(true); // name came from API
        } else {
          setNameFromAPI(false); // no name from API, show input
        };
        setIsloading(false);
      } else {
        SweetAlertPopup(response?.message, "", "error");
        setValue("accnumber", "");
        setValue("accName", "");
        setIsloading(false);
        handleClose();
      }
    } catch (error) {
      console.error("Error verifying account number:", error);
      setVerificationResult({ success: false, message: "Verification failed" });
      handleClose();

    } finally {
      setIsloading(false);
    }
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    const payload = {
      custNo: user?.userId,
      sessionId: user?.sessionId,
      accNo: data.accnumber,
      ifsc: data.ifsccode,
      nickname: data.nickname,
      fullname: data.accName,
      mobileNo: data.mobilenum,
      tpin: data.tpin,
    };

    const response = await postApiData(apiList.BENEFICIARYADD, payload);
    if (response?.status == true) {
      handleClose();
      SweetAlertPopup(response?.message, "Success", "success");
      reset();
      setIsSubmitting(false);
    }
    else if (response?.status === false) {
      if (response?.message === "OTP REQUIRED") {

        handleClose();
        setPayloadData(payload)
        handleOpenOTP();
        // setTimeout(() => {
        //   // handleOpenOTP(); // ⏳ Open after modal is closed
        // }, 3000);
        setIsloading(false);
        return;
      }
      else {
        SweetAlertPopup(response?.message, "Error", "error");
        handleClose();
        setIsSubmitting(false);
      }
    }
    else if (response?.data?.tpinAttempt >= 0) {
      SweetAlertPopup(
        response?.message +
        "\n" +
        (response?.data.tpinAttempt + 1) +
        " Attempts Remaining",
        "Error",
        "error"
      );
      setIsSubmitting(false);
    } else {
      SweetAlertPopup(response?.message, "Error", "error");
      handleClose();
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style} className={classes.box1} component="form" onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.firsttabinfo} style={{ width: "100%" }}>
            <div className={classes.otpContent}>
              <div className={classes.modalupperheading}>{t("add_Benficiary")}</div>
              <div className={classes.cancelButton}>
                <IconButton aria-label="delete" onClick={handleClose}>
                  <HighlightOffIcon />
                </IconButton>
              </div>
            </div>

            <div className={classes.frowdataaff}>
              <div className={classes.frowtextaff}>
                {t("accountNumberLabel")}
                <sup className={classes.required}>*</sup>
              </div>
              <div className={classes.widthtfield}>

                <Controller
                  name="accnumber" // The name should match the key in 'data' object in onSubmit
                  control={control}
                  defaultValue="" // Set an initial value if needed
                  rules={{
                    required:
                      t("account_required")
                  }}
                  render={({ field, fieldState }) => {

                    const handleInputChange = (event) => {
                      const regex = /^[a-zA-Z0-9]*$/; // Alphanumeric regex
                      const { value } = event.target;

                      // Restrict input to valid alphanumeric characters and a maximum of 32
                      if (!regex.test(value)) {
                        event.preventDefault();
                        return;
                      }

                      if (value.length > 32) {
                        return; // Prevent typing beyond 32 characters
                      }

                      field.onChange(value);

                    };

                    return (
                      <TextField
                        id="standard-adornment-password"
                        disabled={false}
                        fullWidth="true"
                        placeholder={t("accountNumberLabel")}

                        {...field} // Spread the 'field' props to bind it to the form's state
                        sx={{
                          "& fieldset": { border: "none" },
                          ".MuiInputBase-root": {
                            borderRadius: "6px",

                            height: "30px",
                            //   backgroundColor: "rgb(238, 239, 247)",
                            backgroundColor: "#FFF",
                            fontSize: "13px",

                            color: "#888",
                            fontWeight: "500",
                            border: "1px solid",
                            marginTop: "4px",
                            "@media (max-width: 600px)": {
                              padding: "20px 0px 20px 0px",
                            },
                            //   width:'130%'
                          },
                        }}

                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        onChange={handleInputChange}
                      />
                    );
                  }}
                />
              </div>

            </div>

            <div className={classes.frowdataaff}>
              <div className={classes.frowtextaff}>
                {t("BeneIFSCCode")}
                <sup className={classes.required}>*</sup>
              </div>
              <div className={classes.widthtfield}>
                <TextFieldForm
                  controlerProps={{
                    control: control,
                    name: "ifsccode",
                    rows: 5,
                    maxRows: 10,
                  }}
                  TextFieldProps={{
                    // label: "Branch",
                    placeholder: t("BeneIFSCCode"),
                    //   style: { width: "130%" },
                    fullWidth: true,
                    // style:{border:'3px solid #ECECEC'}
                    inputProps: { maxLength: 11 },
                  }}
                  // backgroundColor={true}
                  regExp={/^[a-zA-Z0-9]+$/}
                  rules={{
                    required:
                      t("BeneIFSCCodeReq"),

                    pattern: {
                      value: /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
                      message: t("validIFSCCode"),
                    },
                  }}
                  required={true}
                />
              </div>
            </div>

            {!isValidateButtonEnabled && verificationResult?.name && (
              <div className={classes.trueresponse}>
                {t("beneficiary_Verified")}
              </div>
            )}

            <div className={classes.payment1mobileprepaidbutton}>
              <div className={classes.button} style={{ padding: 0 }}>
                <LoadingButton
                  onClick={verifyAccountNumber}
                  variant="contained"
                  type="button"
                  disabled={!isValidateButtonEnabled || isloading}
                  loading={isloading}
                  sx={{
                    backgroundColor: "var(--button-color)",
                    color: "#fff",
                    borderRadius: "8px",
                    width: "175px",
                    height: "37px",
                    '&:hover': { backgroundColor: "var(--button-hover-color)" },
                  }}
                >
                  {t("next_Button")}
                </LoadingButton>


              </div>
            </div>

            {messegeColor && (
              <>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("BeneNickname")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "nickname",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("BeneNickname"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        inputProps: { maxLength: 10 },
                        // style:{border:'3px solid #ECECEC'}
                      }}
                      // backgroundColor={true}
                      regExp={/^[a-zA-Z0-9]+$/}
                      // regExp={/^[a-zA-Z0-9 ]+$/}

                      //   rules={{
                      //     required:
                      //       "Nickname" + errorMessages.error_autocomplete_message,
                      //       pattern: {
                      //         value: /^[0-9]{10}$/,
                      //         message: "Please Enter valid Mobile Number",
                      //       },
                      //   }

                      // }

                      rules={{
                        required:
                          t("BeneNicknameReq"),
                        pattern: {
                          value: /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$/,
                          message:
                            t("pattern_nickname"),
                        },
                      }}
                      required={true}
                    />
                  </div>
                </div>

                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("Cor_accountholdname")}
                    <sup className={classes.required}>*</sup>
                  </div>

                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control,
                        name: "accName",
                        rules: !nameFromAPI
                          ? { required: t("BeneAccountHolderNameReq") }
                          : undefined,
                      }}
                      TextFieldProps={{
                        placeholder: t("Cor_accountholdname"),
                        fullWidth: true,
                        disabled: nameFromAPI, // 👉 disables when name is from API
                        sx: {
                          backgroundColor: nameFromAPI ? "#EEEFF7" : "#FFF",
                        },
                      }}
                      regExp={/^[a-zA-Z0-9 ]+$/}
                      required={!nameFromAPI}
                    />
                  </div>
                </div>

                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("BeneMobileNumber")}
                    {/* <sup className={classes.required}>*</sup> */}
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "mobilenum",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("BeneMobileNumber"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        inputProps: { maxLength: 10 },
                      }}
                      // backgroundColor={true}
                      regExp={/^[0-9]+$/}
                      rules={{
                        pattern: {
                          value: /^(?!0+$)\d{10}$/,
                          message: t("mobile_Valid"),
                        },
                      }}
                      required={false}
                    />
                  </div>


                </div>


                <div className={classes.grid4title}>
                  <div className={classes.frowtextaff}>
                    {t("tpin")} <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.frow1aff}>
                    <Controller
                      name="tpin" // The name should match the key in 'data' object in onSubmit
                      control={control}
                      defaultValue="" // Set an initial value if needed
                      rules={{
                        required: t("tpin_required"),
                        pattern: {
                          value: /^[0-9]{4,}$/, // This pattern allows only digits and requires at least 4 digits
                          message:
                            t("tpin_info"),
                        },
                      }}
                      render={({ field, fieldState }) => {
                        const handleInputChange = (event) => {
                          const regex = /^[0-9]+$/;
                          const { name, value } = event.target;
                          const isValidInput = regex.test(value) || value === "";

                          if (!isValidInput) {
                            event.preventDefault();
                            return;
                          }

                          field.onChange(value);
                        };

                        return (
                          <TextField
                            id="standard-adornment-password"
                            fullWidth="true"
                            placeholder={t("tpin")}
                            maxLength={4}
                            type={showPassword ? "text" : "password"}
                            {...field} // Spread the 'field' props to bind it to the form's state
                            sx={{
                              "& fieldset": { border: "none" },
                              ".MuiInputBase-root": {
                                borderRadius: "6px",
                                position: "relative",
                                // backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
                                backgroundColor: "#FFF",
                                // backgroundColor: backgroundColor?'#FFF' : "#EEEFF7",
                                marginTop: "4px",

                                border: "1px solid",
                                // borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
                                // borderColor: 'red',
                                fontSize: "13px",
                                height: "34px",
                                color: "#888",
                                fontWeight: "500",

                                // width: '520px',
                                padding: "14px 10px",
                                "@media (max-width: 568px)": {
                                  padding: "20px 10px",
                                },
                              },

                            }}
                            inputProps={{ maxLength: 4, minLength: 4 }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {!showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            onChange={handleInputChange}
                          // error={field.error} // Pass the error state here
                          // helperText={passwordError ? "Password does not meet requirements" : ""}
                          />
                        );
                      }}
                    />
                  </div>
                </div>

                <div className={classes.payment1mobileprepaidbutton}>
                  <div className={classes.button} style={{ padding: 0 }}>
                    <LoadingButton
                      variant="contained"
                      type="submit"
                      loading={isSubmitting}
                      sx={{
                        backgroundColor: "var(--button-color)",
                        color: "#fff",
                        borderRadius: "8px",
                        width: "175px",
                        height: "37px",
                        marginTop: "5px",
                        '&:hover': { backgroundColor: "var(--button-hover-color)" },
                      }}
                    >
                      {t("add_Benficiary")}
                    </LoadingButton>
                  </div>
                </div>
              </>
            )}
          </div>
        </Box>

      </Modal>


    </>


  );
}
